
const MissionSection = () => {
  const values = [
    {
      icon: 'ri-book-open-line',
      title: 'Biblical Truth',
      description: 'Every teaching and written word is grounded in Scripture, presenting God\'s truth with clarity and reverence.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Compassionate Care',
      description: 'Ministry flows from a heart of genuine love and concern for the spiritual well-being of every reader.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Practical Wisdom',
      description: 'Biblical principles are presented in ways that can be applied to everyday life and real-world challenges.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Faithful Service',
      description: 'A commitment to serving God\'s people with integrity, humility, and unwavering dedication to His calling.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-xs text-gray-500 uppercase tracking-wider mb-5">(Mission & Vision)</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1B3A52] mb-6">
            Guided by Faith, Driven by Purpose
          </h2>
          <p className="text-base text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Pastor Don's ministry is built on a foundation of biblical truth, compassionate care, and a deep desire to see lives transformed by the Gospel of Jesus Christ.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-[#FDFBF7] rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-5">
                <i className={`${value.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-serif font-bold text-[#1B3A52] mb-3">
                {value.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center bg-gradient-to-r from-[#1B3A52] to-[#2a5270] rounded-3xl p-10 md:p-12">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-5">
            Join the Journey
          </h3>
          <p className="text-base text-white/90 mb-6 max-w-2xl mx-auto">
            Discover how God's Word can transform your life. Explore Pastor Don's books and begin your journey of faith today.
          </p>
          <a
            href="/books"
            className="inline-block bg-white text-[#1B3A52] px-8 py-3 rounded-full text-base font-medium hover:bg-[#F5E6D3] transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            View All Books →
          </a>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
